import { formatInTimeZone } from 'date-fns-tz';

export const getMountainTimeZone = (date: string | null | undefined, replacer: string) => {
  return date ? formatInTimeZone(date!, 'US/Mountain', 'dd-MMM-yyyy HH:mm') : replacer;
};

